// src/pages/WhatIsErc.js
import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import translations from '../translations';
import { useMeta } from '../useMeta';

function WhatIsErc({ language = 'en' }) {
  const t = translations[language] || translations['en'];
  const prefix = language === 'en' ? '' : `/${language}`;

  useMeta({
    title: `${t.whyLocked.title} | ERC Unlock`,
    description: language === 'en'
      ? 'Learn why Toyota head units lock and what an ERC code is. The ERC anti-theft system activates after battery disconnection or replacement. Find out how to unlock your unit for free.'
      : undefined,
    canonical: `https://ercunlock.com${prefix}/what-is-erc`
  });

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ur' ? 'rtl' : 'ltr';
    document.title = `${t.whyLocked.title} | ERC Unlock`;
  }, [language, t.whyLocked.title]);

  return (
    <Layout language={language}>
      <div className="content-card">
        <h1>{t.whyLocked.title}</h1>
        <div className="prose">
          <p>{t.whyLocked.intro}</p>
          {t.whyLocked.sections.map((section, i) => (
            <div key={i}>
              <h2>{section.heading}</h2>
              <p>{section.text}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default WhatIsErc;
